export const CHANGE_APPLICATION_FILTER = "CHANGE_APPLICATION_FILTER";
export const RESET_APPLICATION_FILTER = "RESET_APPLICATION_FILTER";

const initialState = {
  job_position_ids: null,
  min_salary: "",
  max_salary: "",
  analytic_status: "",
  jobApplicationName: "",
  stage_ids: "",
  experience: [0, 99],
  min_experience:"",
  max_experience:"",
  selectedJobPositions: [],
  start_date: null,
  end_date: null,
  order_by: "create_date",
  disabledDate: false,
  applied: false,
  job_position_names:null,
  appByJp:false
};

export default function jobApplicationFilterReducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_APPLICATION_FILTER:
      return {
        ...state,
        ...action.payload,
      };

    case RESET_APPLICATION_FILTER:
      return initialState;

    default:
      return state;
  }
}
